import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 871110B6-9A38-4AEC-89DB-5570E84F109A
 * name star-four-points-small
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-four-points-small.svg
 * tags
 * - Shape 
 */
export const StarFourPointsSmallIcon = createSvgIcon(<><path d="M10.74 10.75L12 8L13.25 10.75L16 12L13.25 13.26L12 16L10.74 13.26L8 12L10.74 10.75Z" /></>, 'StarFourPointsSmallIcon');
export default StarFourPointsSmallIcon